import { useState, useEffect } from 'react'
import { useAuth } from "../context/authContext"
import { useData } from '../context/dataContext';
import TableCruds from '../components/TableCruds'
import BackgroundStyle from "../components/ui/BackgroundStylePage"

const Cruds = () => {
  const { getRegister } = useData();
  const [data, setData] = useState([])
  const [loadingData, setLoadingData] = useState(true)
  const { loading } = useAuth();


  useEffect(() => {
    if (loading) return;

    const fetchData = async () => {
      const registros = await getRegister();
      setData(registros || []);
      setLoadingData(false); 
    };

    fetchData();
  }, [loading]);

  return (
    <>
      {!loading ? (
        <div className="flex flex-row bg-[#F9F9F9]">
          <div className="w-full h-full p-5">
            <TableCruds datos={data} loadingData={loadingData}/>
          </div>
        </div>
      ) : (
        <BackgroundStyle>
          <div className="flex items-center justify-center min-h-screen">
            <h1 className="text-center text-lg px-5 lg:px-0 lg:text-2xl font-semibold font-Poppins text-[#4D4D4D]">
              CARGANDO INFORMACIÓN DE ACTIVIDADES ...
            </h1>
          </div>
        </BackgroundStyle>
      )}
    </>
  );

}

export default Cruds